import { render } from "./BillingNotes.vue?vue&type=template&id=6f429d82"
import script from "./BillingNotes.vue?vue&type=script&lang=js"
export * from "./BillingNotes.vue?vue&type=script&lang=js"

import "./BillingNotes.vue?vue&type=style&index=0&id=6f429d82&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/BillingNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f429d82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f429d82', __exports__)) {
    console.log('reload')
    api.reload('6f429d82', __exports__)
  }
  
  module.hot.accept("./BillingNotes.vue?vue&type=template&id=6f429d82", () => {
    console.log('re-render')
    api.rerender('6f429d82', render)
  })

}


export default __exports__